import { createReducer } from '@reduxjs/toolkit';
import {
    SET_SUBMITTING_FREESTREAMINGMODAL, UNSET_SUBMITTING_FREESTREAMINGMODAL, SET_SUBMITTED_FREESTREAMINGMODAL,
} from '../actions/freeStreamingAction';

const initialState = {
    submitting: false,
    submitted: false,
};

const freeStreaming = createReducer(initialState, (builder) => {
    builder
        .addCase(SET_SUBMITTING_FREESTREAMINGMODAL, (state) => {
            state.submitting = true;
        })
        .addCase(UNSET_SUBMITTING_FREESTREAMINGMODAL, (state) => {
            state.submitting = false;
        })
        .addCase(SET_SUBMITTED_FREESTREAMINGMODAL, (state) => {
            state.submitted = true;
        });
});

export default freeStreaming;
